module.exports = __webpack_public_path__ + "img/1033.ecb78499.svg";